<template>
  <div class="page__shopee-marketing a-page">
    <div class="bg-white p-[10px] rounded-[4px] overflow-hidden" style="height: calc(100vh - 16px);">
      <div class="mt-[10px] px-[10px] flex">
        <div class="flex gap-[20px]">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
        </div>
      </div>

      <div class="mt-[40px] overflow-hidden" style="height: calc(100% - 80px);">
        <div class="flex justify-between px-[10px] pb-[35px] mb-[30px]" style="box-shadow: 0 3px 5px rgba(0,0,0,0.1);">
          <div class="flex-1 pr-[20px]">
            <el-tabs v-model="tab">
              <el-tab-pane label="Báo cáo tổng quan" name="1">
              </el-tab-pane>
              <el-tab-pane label="Báo cáo tổng quan theo chiến dịch" name="2"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="shrink-0 flex gap-[10px]">
            <div>
              <el-select v-if="tab === '2'" v-model="selected_campaign_id" class="w-[220px]" size="mini" value=""
                         :placeholder="'Chọn Campaign ID'" filterable :disabled="loading.get_data"
                         ref="select_campaign_id" @change="m__get_data_by_campaign()">
                <el-option v-for="campaign_id in campaign_ids" :key="campaign_id" :value="campaign_id"
                           :label="campaign_id"></el-option>
              </el-select>
            </div>

            <div class="relative w-[220px]">
              <el-date-picker
                v-model="date_range" type="daterange" range-separator="-" format="dd-MM-yyyy" size="mini"
                :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                :clearable="false" :picker-options="picker_options" :disabled="loading.get_data"
                class="full-w hide-closeable" @change="m__reload_data()">
              </el-date-picker>

              <div class="absolute !w-[220px] top-[40px] left-0">
                <div class="relative w-full">
                  <el-date-picker
                    v-model="same_period_date_range"
                    type="daterange" range-separator="-" format="dd-MM-yyyy" size="mini"
                    :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                    :clearable="false" :picker-options="picker_options" :disabled="loading.get_data"
                    class="!w-[220px] hide-closeable" @change="m__reload_data()">
                  </el-date-picker>

                  <div class="absolute top-[7px] left-[-130px]">
                    <span class="text-[13px] h-[30px] font-semibold">
                      Thời gian đối chiếu:
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="false">
              <el-button size="mini" icon="el-icon-refresh" :loading="loading.get_data" @click="m__reload_data()">
                {{ $t('base.reload_data') }}
              </el-button>
            </div>

            <div v-if="false">
              <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                         @click="m__get_data_by_shop()">
                {{ $t('base.lookup') }}
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="tab === '1'" id="tab-1" class="flex mt-[20px] px-[10px] items-stretch"
             style="height: calc(100% - 115px);" v-loading="loading.get_data">
          <div class="h-full overflow-scroll w-[250px] flex flex-col gap-[30px] pr-[20px] hide-scroll">
            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Số lượng chiến dịch
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ shop_result.total_campaigns | currency }}
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Số ngày chạy Atosa Agent
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ shop_result.active_days | currency }}
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                ROAS từ Atosa Agent
              </div>
              <div class="text-center">
                <span class="text-[30px] text-bold">{{ shop_result.metrics.roas | to_fixed(2) }}</span>
                &nbsp;
                <template v-if="m__get_result_growth('shop_result', 'roas').display">
                  <div v-if="m__get_result_growth('shop_result', 'roas').state === 'up'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#30B556]">
                      <path
                        d="M3.72.574A1 1 0 0 1 5.47.573l3.304 5.94A1 1 0 0 1 7.9 8H1.3a1 1 0 0 1-.875-1.485L3.72.574Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#30B556]">
                      {{ m__get_result_growth('shop_result', 'roas').percent }}%
                    </span>
                  </div>
                  <div v-if="m__get_result_growth('shop_result', 'roas').state === 'down'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#EE2C4A]">
                      <path
                        d="M5.28 7.426a1 1 0 0 1-1.749.001L.227 1.487A1 1 0 0 1 1.1 0h6.6a1 1 0 0 1 .875 1.485L5.28 7.426Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#EE2C4A]">
                      {{ m__get_result_growth('shop_result', 'roas').percent }}%
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Tổng GMV từ Atosa Agent
              </div>
              <div class="text-center">
                <span class="text-[30px] text-bold">{{ m__short_value(shop_result.metrics.gmv) }}</span>
                <template v-if="m__get_result_growth('shop_result', 'gmv').display">
                  <div v-if="m__get_result_growth('shop_result', 'gmv').state === 'up'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#30B556]">
                      <path
                        d="M3.72.574A1 1 0 0 1 5.47.573l3.304 5.94A1 1 0 0 1 7.9 8H1.3a1 1 0 0 1-.875-1.485L3.72.574Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#30B556]">
                      {{ m__get_result_growth('shop_result', 'gmv').percent }}%
                    </span>
                  </div>
                  <div v-if="m__get_result_growth('shop_result', 'gmv').state === 'down'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#EE2C4A]">
                      <path
                        d="M5.28 7.426a1 1 0 0 1-1.749.001L.227 1.487A1 1 0 0 1 1.1 0h6.6a1 1 0 0 1 .875 1.485L5.28 7.426Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#EE2C4A]">
                      {{ m__get_result_growth('shop_result', 'gmv').percent }}%
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[50px]">
                GMV trung bình / chiến dịch từ Atosa Agent
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ m__short_value(shop_result.metrics.avg_gmv) }}
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[50px]">
                GMV trung bình / ngày từ Atosa Agent
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ m__short_value(shop_result.metrics.gmv / shop_result.active_days) }}
              </div>
            </div>
          </div>

          <div class="h-full overflow-scroll flex-1 pl-[45px] pr-[20px]">
            <div v-if="false" class="mb-[25px]">
              <span class="text-[13px] h-[30px] font-bold">
                Thời gian đối chiếu dữ liệu:
              </span>
              &nbsp;
              &nbsp;
              <el-date-picker
                v-model="same_period_date_range" type="daterange" range-separator="-" format="dd-MM-yyyy" size="mini"
                :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                :clearable="false" :picker-options="picker_options" :disabled="loading.get_data"
                class="!w-[220px] hide-closeable" @change="m__reload_data()">
              </el-date-picker>
              <span v-if="false" class="text-[13px] h-[30px] text-bold">
                {{ shop_result.same_period_start_time * 1000 | moment('DD-MM-YYYY') }}
                -
                {{ shop_result.same_period_end_time * 1000 | moment('DD-MM-YYYY') }}
              </span>
            </div>

            <div class="flex flex-col gap-[30px]">
              <div class="flex gap-[20px]">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    ROAS cùng kỳ theo thời gian
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ shop_result.metrics.period_roas | to_fixed(2) }}
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    GMV cùng kỳ theo thời gian
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ m__short_value(shop_result.metrics.period_gmv) }}
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    Tỉ lệ chiến dịch chạy tốt
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ shop_result.good_rate | to_fixed(2) }}%
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    Tỉ lệ chiến dịch chạy không tốt
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ shop_result.bad_rate | to_fixed(2) }}%
                  </div>
                </div>
              </div>

              <div class="flex gap-[20px] flex-wrap">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} chiến dịch có tỉ lệ tăng trưởng ROAS tốt so với cùng kỳ</strong>
                  </div>
                  <div>
                    <highcharts :options="top_campaigns_roas_for_same_period_chart_options"></highcharts>
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} chiến dịch có tỉ lệ tăng trưởng GMV tốt so với cùng kỳ</strong>
                  </div>
                  <div>
                    <highcharts :options="top_campaigns_gmv_for_same_period_chart_options"></highcharts>
                  </div>
                </div>
              </div>

              <div class="flex gap-[20px] flex-wrap">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} chiến dịch có ROAS tốt nhất</strong>
                  </div>
                  <div>
                    <highcharts :options="top_campaigns_roas_chart_options"></highcharts>
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} chiến dịch có GMV tốt nhất</strong>
                  </div>
                  <div>
                    <highcharts :options="top_campaigns_gmv_chart_options"></highcharts>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-[40px]">
              <div class="flex justify-between items-center">
                <strong class="text-[14px]">Danh sách các chiến dịch đang sử dụng Atosa Agent</strong>
                <div>
                  <el-popover
                    placement="right"
                    width="500"
                    trigger="click">
                    <div class="flex flex-wrap gap-[10px]">
                      <el-checkbox v-for="key in Object.keys(selected_metrics)" :key="key"
                                   v-model="selected_metrics[key]" class="w-[25%]"
                                   :disabled="selected_metrics[key] && Object.keys(selected_metrics).filter(i => selected_metrics[i]).length <= 1">
                        {{ $t(`metric.${key}`) }}
                      </el-checkbox>
                    </div>
                    <el-button slot="reference" size="mini" icon="el-icon-s-operation">Chọn chỉ số</el-button>
                  </el-popover>
                  &nbsp;
                  <el-input v-model="search_campaign_keyword" class="w-[250px]" size="mini" prefix-icon="el-icon-search"
                            placeholder="Nhập campaign id, tên sản phẩm" clearable></el-input>
                </div>
              </div>

              <div :key="tab" class="mt-[20px]">
                <el-table :data="c__shop_result_campaigns" :row-style="m__style_for_summary"
                          @sort-change="m__on_sort_change">
                  <el-table-column prop="campaign_id" :label="`Chiến dịch`" width="450px" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="py-[5px] w-full truncate overflow-hidden whitespace-nowrap">
                        <template v-if="scope.row.is_summary">
                          -
                        </template>
                        <template v-else>
                          <a
                            :href="m__get_campaign_detail_link(scope.row)"
                            class="hover:underline"
                            @click="m__go_to_campaign($event, scope.row.campaign_id)">
                            {{ scope.row.campaign_id }}
                            -
                            {{ scope.row.campaign_name }}
                          </a>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="`Chỉ số đạt được`">
                    <el-table-column prop="metrics.impression" :label="$t('metric.impressions')" sortable="custom"
                                     min-width="130" v-if="selected_metrics['impression']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.impression | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'impression')">
                          {{ m__get_row_ratio_text(scope.row, 'impression') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.click" :label="$t('metric.clicks')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['click']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.click | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'click')">
                          {{ m__get_row_ratio_text(scope.row, 'click') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cpc" :label="'CPC'" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cpc']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cpc | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cpc')">
                          {{ m__get_row_ratio_text(scope.row, 'cpc') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.ctr" :label="$t('metric.ctr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['ctr']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.ctr | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'ctr')">
                          {{ m__get_row_ratio_text(scope.row, 'ctr') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.orders" :label="$t('metric.orders')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['orders']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.orders | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'orders')">
                          {{ m__get_row_ratio_text(scope.row, 'orders') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cost" :label="$t('metric.cost')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cost']">
                      <template slot-scope="scope">
                        <div>
                          {{ m__calculate(scope.row.metrics.cost) | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cost')">
                          {{ m__get_row_ratio_text(scope.row, 'cost') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.gmv" :label="$t('metric.gmv')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['gmv']">
                      <template slot-scope="scope">
                        <div>
                          {{ m__calculate(scope.row.metrics.gmv) | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'gmv')">
                          {{ m__get_row_ratio_text(scope.row, 'gmv') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.roas" :label="$t('metric.roas')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['roas']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.roas | to_fixed(2) }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'roas')">
                          {{ m__get_row_ratio_text(scope.row, 'roas') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cir" :label="$t('metric.cir')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cir']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cir | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cir')">
                          {{ m__get_row_ratio_text(scope.row, 'cir') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cr" :label="$t('metric.cr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cr']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cr | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cr')">
                          {{ m__get_row_ratio_text(scope.row, 'cr') }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column :label="`Chỉ số cùng kỳ`">
                    <el-table-column prop="metrics.period_impression" :label="$t('metric.impressions')"
                                     sortable="custom"
                                     min-width="130" v-if="selected_metrics['impression']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_impression | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_click" :label="$t('metric.clicks')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['click']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_click | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cpc" :label="'CPC'" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cpc']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cpc | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_ctr" :label="$t('metric.ctr')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['ctr']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_ctr | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_orders" :label="$t('metric.orders')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['orders']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_orders | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cost" :label="$t('metric.cost')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['cost']">
                      <template slot-scope="scope">
                        {{ m__calculate(scope.row.metrics.period_cost) | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_gmv" :label="$t('metric.gmv')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['gmv']">
                      <template slot-scope="scope">
                        {{ m__calculate(scope.row.metrics.period_gmv) | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_roas" :label="$t('metric.roas')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['roas']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_roas | to_fixed(2) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cir" :label="$t('metric.cir')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['cir']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cir | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cr" :label="$t('metric.cr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cr']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cr | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === '2'" id="tab-2" class="flex mt-[20px] px-[10px] items-stretch"
             style="height: calc(100% - 115px);" v-loading="loading.get_data">
          <div class="max-h-full h-full overflow-scroll w-[250px] flex flex-col gap-[30px] pr-[20px] hide-scroll">
            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Số lượng từ khoá
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ search_campaign_result.total_keywords | currency }}
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Số ngày chạy Atosa Agent
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ search_campaign_result.active_days | currency }}
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                ROAS từ Atosa Agent
              </div>
              <div class="text-center">
                <span class="text-[30px] text-bold">{{ search_campaign_result.metrics.roas | to_fixed(2) }}</span>
                &nbsp;
                <template v-if="m__get_result_growth('search_campaign_result', 'roas').display">
                  <div v-if="m__get_result_growth('search_campaign_result', 'roas').state === 'up'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#30B556]">
                      <path
                        d="M3.72.574A1 1 0 0 1 5.47.573l3.304 5.94A1 1 0 0 1 7.9 8H1.3a1 1 0 0 1-.875-1.485L3.72.574Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#30B556]">
                      {{ m__get_result_growth('search_campaign_result', 'roas').percent }}%
                    </span>
                  </div>
                  <div v-if="m__get_result_growth('search_campaign_result', 'roas').state === 'down'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#EE2C4A]">
                      <path
                        d="M5.28 7.426a1 1 0 0 1-1.749.001L.227 1.487A1 1 0 0 1 1.1 0h6.6a1 1 0 0 1 .875 1.485L5.28 7.426Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#EE2C4A]">
                      {{ m__get_result_growth('search_campaign_result', 'roas').percent }}%
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[30px]">
                Tổng GMV từ Atosa Agent
              </div>
              <div class="text-center">
                <span class="text-[30px] text-bold">{{ m__short_value(search_campaign_result.metrics.gmv) }}</span>
                <template v-if="m__get_result_growth('search_campaign_result', 'gmv').display">
                  <div v-if="m__get_result_growth('search_campaign_result', 'gmv').state === 'up'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#30B556]">
                      <path
                        d="M3.72.574A1 1 0 0 1 5.47.573l3.304 5.94A1 1 0 0 1 7.9 8H1.3a1 1 0 0 1-.875-1.485L3.72.574Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#30B556]">
                      {{ m__get_result_growth('search_campaign_result', 'gmv').percent }}%
                    </span>
                  </div>
                  <div v-if="m__get_result_growth('search_campaign_result', 'gmv').state === 'down'"
                       class="inline-flex items-center gap-[3px] pb-[1px]">
                    <svg viewBox="0 0 9 8" xmlns="http://www.w3.org/2000/svg"
                         class="w-[10px] height-[9px] fill-[#EE2C4A]">
                      <path
                        d="M5.28 7.426a1 1 0 0 1-1.749.001L.227 1.487A1 1 0 0 1 1.1 0h6.6a1 1 0 0 1 .875 1.485L5.28 7.426Z"></path>
                    </svg>
                    <span class="text-[13px] text-bold text-[#EE2C4A]">
                      {{ m__get_result_growth('search_campaign_result', 'gmv').percent }}%
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="w-full min-w-full border border-solid border-gray-300 rounded-[4px] p-[20px] flex flex-col">
              <div class="text-[14px] text-center h-[50px]">
                GMV trung bình từ Atosa Agent
              </div>
              <div class="text-[30px] text-bold text-center">
                {{ m__short_value(search_campaign_result.metrics.avg_gmv) }}
              </div>
            </div>
          </div>

          <div class="max-h-full h-full overflow-scroll flex-1 pl-[45px] pr-[20px]">
            <div v-if="false" class="mb-[25px]">
              <span class="text-[13px] h-[30px] font-bold">
                Thời gian đối chiếu dữ liệu:
              </span>
              &nbsp;
              &nbsp;
              <el-date-picker
                v-model="same_period_date_range" type="daterange" range-separator="-" format="dd-MM-yyyy" size="mini"
                :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')"
                :clearable="false" :picker-options="picker_options" :disabled="loading.get_data"
                class="!w-[220px] hide-closeable" @change="m__reload_data()">
              </el-date-picker>
              <span v-if="false" class="text-[13px] h-[30px] text-bold">
                {{ search_campaign_result.same_period_start_time * 1000 | moment('DD-MM-YYYY') }}
                -
                {{ search_campaign_result.same_period_end_time * 1000 | moment('DD-MM-YYYY') }}
              </span>
            </div>

            <div class="flex flex-col gap-[30px]">
              <div class="flex gap-[20px]">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    ROAS cùng kỳ theo thời gian
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ search_campaign_result.metrics.period_roas | to_fixed(2) }}
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    GMV cùng kỳ theo thời gian
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ m__short_value(search_campaign_result.metrics.period_gmv) }}
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    Tỉ lệ từ khoá chạy tốt
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ search_campaign_result.good_rate | to_fixed(2) }}%
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div class="text-[13px] text-center h-[30px]">
                    Tỉ lệ từ khoá chạy không tốt
                  </div>
                  <div class="text-[25px] text-bold text-center">
                    {{ search_campaign_result.bad_rate | to_fixed(2) }}%
                  </div>
                </div>
              </div>

              <div class="flex gap-[20px] flex-wrap">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} từ khoá có tỉ lệ tăng trưởng ROAS tốt so với cùng kỳ</strong>
                  </div>
                  <div>
                    <highcharts :options="top_keywords_roas_for_same_period_chart_options"></highcharts>
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} từ khoá có tỉ lệ tăng trưởng GMV tốt so với cùng kỳ</strong>
                  </div>
                  <div>
                    <highcharts :options="top_keywords_gmv_for_same_period_chart_options"></highcharts>
                  </div>
                </div>
              </div>

              <div class="flex gap-[20px] flex-wrap">
                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} từ khoá có ROAS tốt nhất</strong>
                  </div>
                  <div>
                    <highcharts :options="top_keywords_roas_chart_options"></highcharts>
                  </div>
                </div>

                <div class="flex-1 border border-solid border-gray-300 rounded-[4px] p-[10px]">
                  <div>
                    <strong>Top {{ select_top }} từ khoá có GMV tốt nhất</strong>
                  </div>
                  <div>
                    <highcharts :options="top_keywords_gmv_chart_options"></highcharts>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-[40px]">
              <div class="flex justify-between items-center">
                <strong class="text-[14px]">Danh sách từ khoá được vận hành bởi Atosa Agent</strong>

                <div>
                  <el-popover
                    placement="right"
                    width="500"
                    trigger="click">
                    <div class="flex flex-wrap gap-[10px]">
                      <el-checkbox v-for="key in Object.keys(selected_metrics)" :key="key"
                                   v-model="selected_metrics[key]" class="w-[25%]"
                                   :disabled="selected_metrics[key] && Object.keys(selected_metrics).filter(i => selected_metrics[i]).length <= 1">
                        {{ $t(`metric.${key}`) }}
                      </el-checkbox>
                    </div>
                    <el-button slot="reference" size="mini" icon="el-icon-s-operation">Chọn chỉ số</el-button>
                  </el-popover>
                  &nbsp;
                  <el-input v-model="search_keywords_keyword" class="w-[250px]" size="mini" prefix-icon="el-icon-search"
                            placeholder="Nhập từ khoá" clearable></el-input>
                </div>
              </div>

              <div :key="tab" class="mt-[20px]">
                <el-table :data="c__search_campaign_result_keywords" :row-style="m__style_for_summary"
                          @sort-change="m__on_sort_change">
                  <el-table-column prop="campaign_id" :label="`Từ khóa`" min-width="280px" show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                      <el-dropdown trigger="click" @command="(c) => {selected_keyword_type = c}">
                        <el-button type="text" size="mini">
                          <strong :class="{'text-primary': selected_keyword_type !== 'all'}">
                            <template v-if="selected_keyword_type === 'all'">
                              {{ 'Tất cả từ khóa' }}
                            </template>
                            <template v-if="selected_keyword_type === 'atosa_agent'">
                              {{ 'Được thêm bởi Atosa Agent' }}
                            </template>
                            <template v-if="selected_keyword_type === 'not_atosa_agent'">
                              {{ 'Không được thêm bởi Atosa Agent' }}
                            </template>
                            <i :class="'el-icon-caret-bottom'"></i>
                          </strong>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="all">
                            <div style="display: flex; gap: 10px">
                              <span style="flex: auto">{{ $t('keyword.all') }}</span>
                              <span style="width: 10px">
                                <i v-if="selected_keyword_type === 'all'" class="el-icon-check"></i>
                              </span>
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item command="atosa_agent">
                            <div style="display: flex; gap: 10px">
                              <span style="flex: auto">{{ 'Được thêm bởi Atosa Agent' }}</span>
                              <span style="width: 10px">
                                <i v-if="selected_keyword_type === 'atosa_agent'" class="el-icon-check"></i>
                              </span>
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item command="not_atosa_agent">
                            <div style="display: flex; gap: 10px">
                              <span style="flex: auto">{{ 'Không được thêm bởi Atosa Agent' }}</span>
                              <span style="width: 10px">
                                <i v-if="selected_keyword_type === 'not_atosa_agent'" class="el-icon-check"></i>
                              </span>
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                    <template slot-scope="scope">
                      <div class="py-[5px] w-full truncate overflow-hidden whitespace-nowrap">
                        <template v-if="scope.row.is_summary">
                          -
                        </template>
                        <template v-else>
                          <template v-if="added_keywords_from_atosa_agent_set.has(scope.row.keyword)">
                            <el-tooltip placement="top" effect="light" content="Từ khóa được thêm bởi Atosa Agent">
                              <a href="javascript:void(0)"
                                 class="atosa-keyword text-[#409eff] !font-bold hover:underline"
                                 @click="search_keywords_keyword = scope.row.keyword">
                                {{ scope.row.keyword }}
                              </a>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <a href="javascript:void(0)" class="hover:underline text-black"
                               @click="search_keywords_keyword = scope.row.keyword">
                              {{ scope.row.keyword }}
                            </a>
                          </template>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="`Chỉ số đạt được`">
                    <el-table-column prop="metrics.impression" :label="$t('metric.impressions')" sortable="custom"
                                     min-width="130" v-if="selected_metrics['impression']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.impression | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'impression')">
                          {{ m__get_row_ratio_text(scope.row, 'impression') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.click" :label="$t('metric.clicks')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['click']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.click | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'click')">
                          {{ m__get_row_ratio_text(scope.row, 'click') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cpc" :label="'CPC'" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cpc']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cpc | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cpc')">
                          {{ m__get_row_ratio_text(scope.row, 'cpc') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.ctr" :label="$t('metric.ctr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['ctr']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.ctr | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'ctr')">
                          {{ m__get_row_ratio_text(scope.row, 'ctr') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.orders" :label="$t('metric.orders')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['orders']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.orders | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'orders')">
                          {{ m__get_row_ratio_text(scope.row, 'orders') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cost" :label="$t('metric.cost')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cost']">
                      <template slot-scope="scope">
                        <div>
                          {{ m__calculate(scope.row.metrics.cost) | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cost')">
                          {{ m__get_row_ratio_text(scope.row, 'cost') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.gmv" :label="$t('metric.gmv')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['gmv']">
                      <template slot-scope="scope">
                        <div>
                          {{ m__calculate(scope.row.metrics.gmv) | currency }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'gmv')">
                          {{ m__get_row_ratio_text(scope.row, 'gmv') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.roas" :label="$t('metric.roas')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['roas']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.roas | to_fixed(2) }}
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'roas')">
                          {{ m__get_row_ratio_text(scope.row, 'roas') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cir" :label="$t('metric.cir')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cir']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cir | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cir')">
                          {{ m__get_row_ratio_text(scope.row, 'cir') }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.cr" :label="$t('metric.cr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cr']">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.metrics.cr | to_fixed(2) }}%
                        </div>
                        <div :class="m__get_row_ratio_class(scope.row, 'cr')">
                          {{ m__get_row_ratio_text(scope.row, 'cr') }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column :label="`Chỉ số cùng kỳ`">
                    <el-table-column prop="metrics.period_impression" :label="$t('metric.impressions')"
                                     sortable="custom"
                                     min-width="130" v-if="selected_metrics['impression']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_impression | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_click" :label="$t('metric.clicks')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['click']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_click | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cpc" :label="'CPC'" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cpc']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cpc | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_ctr" :label="$t('metric.ctr')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['ctr']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_ctr | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_orders" :label="$t('metric.orders')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['orders']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_orders | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cost" :label="$t('metric.cost')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['cost']">
                      <template slot-scope="scope">
                        {{ m__calculate(scope.row.metrics.period_cost) | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_gmv" :label="$t('metric.gmv')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['gmv']">
                      <template slot-scope="scope">
                        {{ m__calculate(scope.row.metrics.period_gmv) | currency }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_roas" :label="$t('metric.roas')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['roas']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_roas | to_fixed(2) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cir" :label="$t('metric.cir')" sortable="custom"
                                     min-width="130"
                                     v-if="selected_metrics['cir']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cir | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                    <el-table-column prop="metrics.period_cr" :label="$t('metric.cr')" sortable="custom" min-width="130"
                                     v-if="selected_metrics['cr']">
                      <template slot-scope="scope">
                        {{ scope.row.metrics.period_cr | to_fixed(2) }}%
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div v-if="true" class="mt-[40px]">
              <div class="flex justify-between items-center">
                <strong class="text-[14px]">Nhận định tổng quan</strong>
              </div>

              <div class="mt-[20px]">
                <div
                  v-html="search_campaign_result ? m__analyze_keyword_metrics_html(search_campaign_result.keywords) : ''"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import {get_shop_mixins} from '../../../mixins/get_shop'
import {fix_ads_mixins} from '../../../mixins/fix_ads'
import {picker_options} from '../../../addon/options'
import {orderBy as _orderBy} from "lodash";

const chart_options_template = {
  chart: {
    type: 'bar',
    backgroundColor: 'transparent',
    height: 180,
  },
  title: {
    text: '',
  },
  xAxis: {
    categories: [],
    title: {text: null},
    labels: {style: {fontSize: '12px'}},
  },
  yAxis: {
    title: {text: null},
    labels: {style: {fontSize: '12px'}},
  },
  legend: {
    enabled: false,
  },
  tooltip: {},
  series: [],
  plotOptions: {
    series: {
      borderRadius: 3,
    },
  },
}

export default {
  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    highcharts: Chart,
  },

  data() {
    return {
      tab: '1',
      date_range: [
        this.dayjs().date === 1 ? this.dayjs().subtract(1, 'month').startOf('month').toDate() : this.dayjs().startOf('month').toDate(),
        this.dayjs().date === 1 ? this.dayjs().subtract(1, 'month').endOf('month').toDate() : this.dayjs().subtract(1, 'day').endOf('day').toDate()
      ],
      // date_range: [
      //   this.dayjs().subtract(1, 'day').startOf('day').toDate(),
      //   this.dayjs().subtract(1, 'day').endOf('day').toDate()
      // ],
      // date_range: [new Date(), new Date()],
      same_period_date_range: [],
      picker_options: picker_options,

      loading: {
        get_data: false,
      },

      selected_metrics: {
        impression: true,
        click: true,
        cpc: true,
        ctr: false,
        orders: false,
        cost: false,
        gmv: true,
        roas: true,
        cir: false,
        cr: false,
      },

      shop_result: {
        total_campaigns: 0,
        active_days: 0,
        metrics: {
          roas: 0,
          gmv: 0,
          avg_gmv: 0,
          cost: 0,
          cpc: 0,
          impression: 0,
          click: 0,
          cir: 0,
          period_roas: 0,
          period_gmv: 0,
          period_avg_gmv: 0,
          period_cost: 0,
          period_cpc: 0,
          period_impression: 0,
          period_click: 0,
          period_cir: 0,
        },
        good_rate: 0,
        bad_rate: 0,
        campaigns: [],
        best_roas_campaign_ids: [],
        best_roas_for_same_period_campaign_ids: [],
        best_gmv_campaign_ids: [],
        best_gmv_for_same_period_campaign_ids: [],
        same_period_start_time: null,
        same_period_end_time: null,
      },

      search_campaign_result: {
        total_keywords: 0,
        active_days: 0,
        metrics: {
          roas: 0,
          gmv: 0,
          avg_gmv: 0,
          cost: 0,
          cpc: 0,
          impression: 0,
          click: 0,
          cir: 0,
          ctr: 0,
          orders: 0,
          cr: 0,
          period_roas: 0,
          period_gmv: 0,
          period_avg_gmv: 0,
          period_cost: 0,
          period_cpc: 0,
          period_impression: 0,
          period_click: 0,
          period_cir: 0,
          period_ctr: 0,
          period_orders: 0,
          period_cr: 0,
        },
        good_rate: 0,
        bad_rate: 0,
        keywords: [],
        best_roas_keywords: [],
        best_roas_for_same_period_keywords: [],
        best_gmv_keywords: [],
        best_gmv_for_same_period_keywords: [],
        same_period_start_time: null,
        same_period_end_time: null,
      },
      keywords_stats: [],
      added_keywords_from_atosa_agent: [],
      added_keywords_from_atosa_agent_set: new Set(),
      selected_keyword_type: 'all',

      select_top: 3,
      top_campaigns_roas_chart_options: Object.assign(chart_options_template, {}),
      top_campaigns_roas_for_same_period_chart_options: Object.assign(chart_options_template, {}),
      top_campaigns_gmv_chart_options: Object.assign(chart_options_template, {}),
      top_campaigns_gmv_for_same_period_chart_options: Object.assign(chart_options_template, {}),

      top_keywords_roas_chart_options: Object.assign(chart_options_template, {}),
      top_keywords_roas_for_same_period_chart_options: Object.assign(chart_options_template, {}),
      top_keywords_gmv_chart_options: Object.assign(chart_options_template, {}),
      top_keywords_gmv_for_same_period_chart_options: Object.assign(chart_options_template, {}),

      campaign_ids: [],
      selected_campaign_id: null,
      search_campaign_keyword: '',
      search_keywords_keyword: '',

      sort_option: {
        order: null,
        prop: null
      },
    }
  },

  async created() {
    await this.m__get_shopee_shop()
    await this.$nextTick()
    const {
      campaign_id,
      start_time,
      end_time,
      same_period_start_time,
      same_period_end_time
    } = this.$route.query
    if (campaign_id) {
      this.tab = '2'
      this.selected_campaign_id = +campaign_id
      if (start_time && end_time) {
        this.date_range = [this.dayjs(+start_time * 1000).toDate(), this.dayjs(+end_time * 1000).toDate()]
      }
      if (same_period_start_time && same_period_end_time) {
        this.same_period_date_range = [this.dayjs(+same_period_start_time * 1000).toDate(), this.dayjs(+same_period_end_time * 1000).toDate()]
      }
      this.m__go_to_campaign(null, this.selected_campaign_id)
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
      this.m__get_data_by_shop()
    },

    'tab': function () {
      if (this.tab === '2' && !this.selected_campaign_id) {
        this.$nextTick(() => {
          if (this.$refs['select_campaign_id']) this.$refs['select_campaign_id'].focus()
        })
      }
    },
  },

  computed: {
    c__shop_result_campaigns() {
      let result = this.shop_result.campaigns

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.search_campaign_keyword)
      result = result.filter(item => this.remove_unicode(JSON.stringify({
        campaign_id: item.campaign_id,
        campaign_name: item.campaign_name,
      }).normalize()).includes(words))

      const summary = {
        is_summary: true,
        campaign_id: null,
        campaign_name: null,
        metrics: {
          roas: 0,
          gmv: 0,
          avg_gmv: 0,
          cost: 0,
          cpc: 0,
          impression: 0,
          click: 0,
          cir: 0,
          ctr: 0,
          orders: 0,
          cr: 0,
          period_roas: 0,
          period_gmv: 0,
          period_avg_gmv: 0,
          period_cost: 0,
          period_cpc: 0,
          period_impression: 0,
          period_click: 0,
          period_cir: 0,
          period_ctr: 0,
          period_orders: 0,
          period_cr: 0,
        },
        ratio: {}
      }
      for (const item of result) {
        summary.metrics.roas += item.metrics.roas
        summary.metrics.gmv += item.metrics.gmv
        summary.metrics.avg_gmv += item.metrics.avg_gmv
        summary.metrics.cost += item.metrics.cost
        summary.metrics.cpc += item.metrics.cpc
        summary.metrics.impression += item.metrics.impression
        summary.metrics.click += item.metrics.click
        summary.metrics.cir += item.metrics.cir
        summary.metrics.ctr += item.metrics.ctr
        summary.metrics.orders += item.metrics.orders
        summary.metrics.cr += item.metrics.cr
        summary.metrics.period_roas += item.metrics.period_roas
        summary.metrics.period_gmv += item.metrics.period_gmv
        summary.metrics.period_avg_gmv += item.metrics.period_avg_gmv
        summary.metrics.period_cost += item.metrics.period_cost
        summary.metrics.period_cpc += item.metrics.period_cpc
        summary.metrics.period_impression += item.metrics.period_impression
        summary.metrics.period_click += item.metrics.period_click
        summary.metrics.period_cir += item.metrics.period_cir
        summary.metrics.period_ctr += item.metrics.period_ctr
        summary.metrics.period_orders += item.metrics.period_orders
        summary.metrics.period_cr += item.metrics.period_cr
      }

      summary.metrics.ctr = summary.metrics.impression ? summary.metrics.click / summary.metrics.impression * 100 : 0
      summary.metrics.period_ctr = summary.metrics.period_impression ? summary.metrics.period_click / summary.metrics.period_impression * 100 : 0
      summary.metrics.cpc = summary.metrics.click ? this.m__calculate(summary.metrics.cost / summary.metrics.click) : 0
      summary.metrics.period_cpc = summary.metrics.period_click ? this.m__calculate(summary.metrics.period_cost / summary.metrics.period_click) : 0
      summary.metrics.roas = summary.metrics.cost ? summary.metrics.gmv / summary.metrics.cost : 0
      summary.metrics.period_roas = summary.metrics.period_cost ? summary.metrics.period_gmv / summary.metrics.period_cost : 0
      summary.metrics.cir = summary.metrics.gmv ? summary.metrics.click / summary.metrics.gmv * 100 : 0
      summary.metrics.period_cir = summary.metrics.period_gmv ? summary.metrics.period_click / summary.metrics.period_gmv * 100 : 0
      summary.metrics.cr = summary.metrics.orders ? summary.metrics.click / summary.metrics.orders * 100 : 0
      summary.metrics.period_cr = summary.metrics.period_orders ? summary.metrics.period_click / summary.metrics.period_orders * 100 : 0

      for (const key of Object.keys(summary.metrics)) {
        summary.ratio[key] = summary.metrics[`period_${key}`] === 0
          ? (summary.metrics[key] > 0 ? 100 : 0)
          : (summary.metrics[key] - summary.metrics[`period_${key}`]) / summary.metrics[`period_${key}`] * 100
      }

      return [summary, ...result]
    },

    c__search_campaign_result_keywords() {
      let result = this.search_campaign_result.keywords

      if (this.selected_keyword_type === 'atosa_agent') {
        result = result.filter(i => this.added_keywords_from_atosa_agent_set.has(i.keyword))
      }
      if (this.selected_keyword_type === 'not_atosa_agent') {
        result = result.filter(i => !this.added_keywords_from_atosa_agent_set.has(i.keyword))
      }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.search_keywords_keyword)
      result = result.filter(item => this.remove_unicode(JSON.stringify({
        keyword: item.keyword,
      }).normalize()).includes(words))

      const summary = {
        is_summary: true,
        keyword: null,
        metrics: {
          roas: 0,
          gmv: 0,
          avg_gmv: 0,
          cost: 0,
          cpc: 0,
          impression: 0,
          click: 0,
          cir: 0,
          ctr: 0,
          orders: 0,
          cr: 0,
          period_roas: 0,
          period_gmv: 0,
          period_avg_gmv: 0,
          period_cost: 0,
          period_cpc: 0,
          period_impression: 0,
          period_click: 0,
          period_cir: 0,
          period_ctr: 0,
          period_orders: 0,
          period_cr: 0,
        },
        ratio: {}
      }
      for (const item of result) {
        summary.metrics.roas += item.metrics.roas
        summary.metrics.gmv += item.metrics.gmv
        summary.metrics.avg_gmv += item.metrics.avg_gmv
        summary.metrics.cost += item.metrics.cost
        summary.metrics.cpc += item.metrics.cpc
        summary.metrics.impression += item.metrics.impression
        summary.metrics.click += item.metrics.click
        summary.metrics.cir += item.metrics.cir
        summary.metrics.ctr += item.metrics.ctr
        summary.metrics.orders += item.metrics.orders
        summary.metrics.cr += item.metrics.cr
        summary.metrics.period_roas += item.metrics.period_roas
        summary.metrics.period_gmv += item.metrics.period_gmv
        summary.metrics.period_avg_gmv += item.metrics.period_avg_gmv
        summary.metrics.period_cost += item.metrics.period_cost
        summary.metrics.period_cpc += item.metrics.period_cpc
        summary.metrics.period_impression += item.metrics.period_impression
        summary.metrics.period_click += item.metrics.period_click
        summary.metrics.period_cir += item.metrics.period_cir
        summary.metrics.period_ctr += item.metrics.period_ctr
        summary.metrics.period_orders += item.metrics.period_orders
        summary.metrics.period_cr += item.metrics.period_cr
      }

      summary.metrics.ctr = summary.metrics.impression ? summary.metrics.click / summary.metrics.impression * 100 : 0
      summary.metrics.period_ctr = summary.metrics.period_impression ? summary.metrics.period_click / summary.metrics.period_impression * 100 : 0
      summary.metrics.cpc = summary.metrics.click ? this.m__calculate(summary.metrics.cost / summary.metrics.click) : 0
      summary.metrics.period_cpc = summary.metrics.period_click ? this.m__calculate(summary.metrics.period_cost / summary.metrics.period_click) : 0
      summary.metrics.roas = summary.metrics.cost ? summary.metrics.gmv / summary.metrics.cost : 0
      summary.metrics.period_roas = summary.metrics.period_cost ? summary.metrics.period_gmv / summary.metrics.period_cost : 0
      summary.metrics.cir = summary.metrics.gmv ? summary.metrics.click / summary.metrics.gmv * 100 : 0
      summary.metrics.period_cir = summary.metrics.period_gmv ? summary.metrics.period_click / summary.metrics.period_gmv * 100 : 0
      summary.metrics.cr = summary.metrics.orders ? summary.metrics.click / summary.metrics.orders * 100 : 0
      summary.metrics.period_cr = summary.metrics.period_orders ? summary.metrics.period_click / summary.metrics.period_orders * 100 : 0

      for (const key of Object.keys(summary.metrics)) {
        summary.ratio[key] = summary.metrics[`period_${key}`] === 0
          ? (summary.metrics[key] > 0 ? 100 : 0)
          : (summary.metrics[key] - summary.metrics[`period_${key}`]) / summary.metrics[`period_${key}`] * 100
      }

      return [summary, ...result]
    },

    c__keywords_stats() {
      let result = this.keywords_stats

      const words = this.remove_unicode(this.search_keywords_keyword)
      result = result.filter(item => this.remove_unicode(JSON.stringify({
        keyword: item.keyword,
      }).normalize()).includes(words))

      return result
    },
  },

  methods: {
    m__get_campaign_detail_link(campaign) {
      let url = `/marketing/log/atosa_ai_performance?shop_id=${this.shop.shop_id}&campaign_id=${campaign.campaign_id}`

      if (this.date_range[0]) url += `&start_time=${this.dayjs(this.date_range[0]).unix()}`
      if (this.date_range[1]) url += `&end_time=${this.dayjs(this.date_range[1]).unix()}`
      if (this.same_period_date_range[0]) url += `&same_period_start_time=${this.dayjs(this.same_period_date_range[0]).unix()}`
      if (this.same_period_date_range[1]) url += `&same_period_end_time=${this.dayjs(this.same_period_date_range[1]).unix()}`

      return url
    },

    m__get_row_ratio_class(row, key) {
      if (row.ratio && row.ratio[key] > 0) return 'mt-[3px] text-[10.3px] text-success font-semibold'
      if (row.ratio && row.ratio[key] < 0) return 'mt-[3px] text-[10.3px] text-danger font-semibold'
      return 'mt-[3px] text-[10.3px] text-[#999] font-semibold'
    },

    m__get_row_ratio_text(row, key) {
      return !row.ratio || row.ratio[key] === 0 ? '-' : `${parseFloat(row.ratio[key].toFixed(2))}%`
    },

    m__get_metric_keywords_stats_class(data, key) {
      if (data.metrics[key].value === 'increase') return 'text-success font-semibold'
      if (data.metrics[key].value === 'decrease') return 'text-danger font-semibold'
      return 'font-semibold'
    },

    m__get_metric_keywords_stats_text(keyword, key) {
      if (keyword.metrics[key].value === '-') return 'Không đổi'
      return `${keyword.metrics[key].label} ${keyword.metrics[key].ratio.toFixed(2)}%`
    },

    m__on_sort_change({
                        prop,
                        order
                      }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    m__style_for_summary({row}) {
      if (row.is_summary) return {'background-color': '#F5F7FA'}
    },

    m__get_result_growth(result, key) {
      if (this[result] && this[result].metrics.hasOwnProperty(key) && this[result].metrics.hasOwnProperty(`period_${key}`)) {
        const diff = this[result].metrics[key] - this[result].metrics[`period_${key}`]
        const percent = (diff / this[result].metrics[`period_${key}`]) * 100

        if (Number.isNaN(percent)) {
          return {
            display: true,
            percent: 0,
            state: 'down'
          }
        }

        if (percent === Infinity) {
          return {
            display: true,
            percent: 100,
            state: 'up'
          }
        }

        return {
          display: true,
          percent: Math.abs(percent).toFixed(2),
          state: diff > 0 ? 'up' : 'down'
        }
      }

      return {
        display: false,
        percent: 0,
        state: ''
      }
    },

    async m__get_data_by_shop() {
      if (!this.shop || !this.shop._id) return

      this.top_campaigns_roas_chart_options = this.clone(chart_options_template)
      this.top_campaigns_gmv_chart_options = this.clone(chart_options_template)
      this.top_campaigns_roas_for_same_period_chart_options = this.clone(chart_options_template)
      this.top_campaigns_gmv_for_same_period_chart_options = this.clone(chart_options_template)

      this.loading.get_data = true

      try {
        const campaign_ids_response = await this.$http.post(
          this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_campaign_ids', {
            shop_id: this.shop._id,
          }, this.cf())
        this.campaign_ids = campaign_ids_response.body.data

        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_report_by_shop',
          {
            shop_id: this.shop._id,
            start_time: this.dayjs(this.date_range[0]).unix(),
            end_time: this.dayjs(this.date_range[1]).unix(),
            ...(this.same_period_date_range[0] && {period_start_time: this.dayjs(this.same_period_date_range[0]).unix()}),
            ...(this.same_period_date_range[1] && {period_end_time: this.dayjs(this.same_period_date_range[1]).unix()}),
          }, this.cf())
        if (response && response.body && response.body.data) {
          this.shop_result = response.body.data
          this.same_period_date_range = [
            new Date(this.shop_result.same_period_start_time * 1000),
            new Date(this.shop_result.same_period_end_time * 1000)
          ]

          if (this.shop_result.best_roas_campaign_ids && this.shop_result.best_roas_campaign_ids.length) {
            const top_campaign_ids = this.shop_result.best_roas_campaign_ids.slice(0, this.select_top)
            this.top_campaigns_roas_chart_options.xAxis.categories = []
            this.top_campaigns_roas_chart_options.series = [
              {
                name: 'ROAS',
                data: [],
                color: '#30b556',
              },
            ]

            for (const campaign_id of top_campaign_ids) {
              const campaign_found = this.shop_result.campaigns.find(i => i.campaign_id === campaign_id)
              this.top_campaigns_roas_chart_options.xAxis.categories.push(campaign_found.campaign_id)
              this.top_campaigns_roas_chart_options.series[0].data.push(+campaign_found.metrics.roas.toFixed(2))
            }

            this.top_campaigns_roas_chart_options = this.clone(this.top_campaigns_roas_chart_options)
          }

          if (
            this.shop_result.best_roas_for_same_period_campaign_ids &&
            this.shop_result.best_roas_for_same_period_campaign_ids.length
          ) {
            const top_campaign_ids = this.shop_result.best_roas_for_same_period_campaign_ids.slice(0, this.select_top)
            this.top_campaigns_roas_for_same_period_chart_options.xAxis.categories = []
            this.top_campaigns_roas_for_same_period_chart_options.series = [
              {
                name: 'ROAS',
                data: [],
                color: '#30b556',
              },
              {
                name: 'ROAS cùng kỳ',
                data: [],
                color: 'purple',
              },
            ]

            for (const campaign_id of top_campaign_ids) {
              const campaign_found = this.shop_result.campaigns.find(i => i.campaign_id === campaign_id)
              this.top_campaigns_roas_for_same_period_chart_options.xAxis.categories.push(campaign_found.campaign_id)
              this.top_campaigns_roas_for_same_period_chart_options.series[0].data.push(
                +campaign_found.metrics.roas.toFixed(2))
              this.top_campaigns_roas_for_same_period_chart_options.series[1].data.push(
                +campaign_found.metrics.period_roas.toFixed(2),
              )
            }

            this.top_campaigns_roas_for_same_period_chart_options = this.clone(
              this.top_campaigns_roas_for_same_period_chart_options)
          }

          if (this.shop_result.best_gmv_campaign_ids && this.shop_result.best_gmv_campaign_ids.length) {
            const top_campaign_ids = this.shop_result.best_gmv_campaign_ids.slice(0, this.select_top)
            this.top_campaigns_gmv_chart_options.series = [
              {
                name: 'GMV',
                data: [],
                color: '#30b556',
              },
            ]

            for (const campaign_id of top_campaign_ids) {
              const campaign_found = this.shop_result.campaigns.find(i => i.campaign_id === campaign_id)
              this.top_campaigns_gmv_chart_options.xAxis.categories.push(campaign_found.campaign_id)
              this.top_campaigns_gmv_chart_options.series[0].data.push(campaign_found.metrics.gmv)
            }

            this.top_campaigns_gmv_chart_options = this.clone(this.top_campaigns_gmv_chart_options)
          }

          if (
            this.shop_result.best_gmv_for_same_period_campaign_ids &&
            this.shop_result.best_gmv_for_same_period_campaign_ids.length
          ) {
            const top_campaign_ids = this.shop_result.best_gmv_for_same_period_campaign_ids.slice(0, this.select_top)
            this.top_campaigns_gmv_for_same_period_chart_options.series = [
              {
                name: 'GMV',
                data: [],
                color: '#30b556',
              },
              {
                name: 'GMV cùng kỳ',
                data: [],
                color: 'purple',
              },
            ]

            for (const campaign_id of top_campaign_ids) {
              const campaign_found = this.shop_result.campaigns.find(i => i.campaign_id === campaign_id)
              this.top_campaigns_gmv_for_same_period_chart_options.xAxis.categories.push(campaign_found.campaign_id)
              this.top_campaigns_gmv_for_same_period_chart_options.series[0].data.push(campaign_found.metrics.gmv)
              this.top_campaigns_gmv_for_same_period_chart_options.series[1].data.push(
                campaign_found.metrics.period_gmv)
            }

            this.top_campaigns_gmv_for_same_period_chart_options = this.clone(
              this.top_campaigns_gmv_for_same_period_chart_options)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.get_data = false
      }
    },

    async m__get_data_by_campaign() {
      if (!this.selected_campaign_id) return

      this.top_keywords_roas_chart_options = this.clone(chart_options_template)
      this.top_keywords_gmv_chart_options = this.clone(chart_options_template)
      this.top_keywords_roas_for_same_period_chart_options = this.clone(chart_options_template)
      this.top_keywords_gmv_for_same_period_chart_options = this.clone(chart_options_template)

      this.loading.get_data = true
      try {
        const response = await this.$http.post(
          this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_report_by_campaign', {
            shop_id: this.shop._id,
            campaign_id: this.selected_campaign_id,
            start_time: this.dayjs(this.date_range[0]).unix(),
            end_time: this.dayjs(this.date_range[1]).unix(),
            ...(this.same_period_date_range[0] && {period_start_time: this.dayjs(this.same_period_date_range[0]).unix()}),
            ...(this.same_period_date_range[1] && {period_end_time: this.dayjs(this.same_period_date_range[1]).unix()}),
            override: false
          }, this.cf())
        if (response && response.body && response.body.data) {
          this.search_campaign_result = response.body.data
          this.keywords_stats = []
          this.same_period_date_range = [
            new Date(this.search_campaign_result.same_period_start_time * 1000),
            new Date(this.search_campaign_result.same_period_end_time * 1000)
          ]

          if (this.search_campaign_result.keywords) {
            for (const keyword of this.search_campaign_result.keywords) {
              const row = {
                keyword: keyword.keyword,
                metrics: {}
              }

              for (const key of Object.keys(keyword.metrics)) {
                if (key.startsWith('period_')) continue;

                const stats = {
                  label: 'Không đổi',
                  value: '-',
                  ratio: 0,
                }
                if (keyword.metrics[key] > keyword.metrics[`period_${key}`]) {
                  stats.label = 'Tăng'
                  stats.value = 'increase'
                  stats.ratio = keyword.metrics[`period_${key}`] > 0 ? ((keyword.metrics[key] - keyword.metrics[`period_${key}`]) / keyword.metrics[`period_${key}`]) * 100 : 0
                }
                if (keyword.metrics[key] < keyword.metrics[`period_${key}`]) {
                  stats.label = 'Giảm'
                  stats.value = 'decrease'
                  stats.ratio = keyword.metrics[`period_${key}`] > 0 ? ((keyword.metrics[`period_${key}`] - keyword.metrics[key]) / keyword.metrics[`period_${key}`]) * 100 : 0
                }

                row.metrics[key] = stats
              }

              this.keywords_stats.push(row)
            }
          }

          if (
            this.search_campaign_result.best_roas_keywords &&
            this.search_campaign_result.best_roas_keywords.length
          ) {
            const top_campaign_ids = this.search_campaign_result.best_roas_keywords.slice(0, this.select_top)
            this.top_keywords_roas_chart_options.xAxis.categories = []
            this.top_keywords_roas_chart_options.series = [
              {
                name: 'ROAS',
                data: [],
                color: '#30b556',
              },
            ]

            for (const keyword of top_campaign_ids) {
              const keyword_found = this.search_campaign_result.keywords.find(i => i.keyword === keyword)
              this.top_keywords_roas_chart_options.xAxis.categories.push(keyword_found.keyword)
              this.top_keywords_roas_chart_options.series[0].data.push(+keyword_found.metrics.roas.toFixed(2))
            }

            this.top_keywords_roas_chart_options = this.clone(this.top_keywords_roas_chart_options)
          }

          if (
            this.search_campaign_result.best_gmv_keywords &&
            this.search_campaign_result.best_gmv_keywords.length
          ) {
            const top_campaign_ids = this.search_campaign_result.best_gmv_keywords.slice(0, this.select_top)
            this.top_keywords_gmv_chart_options.xAxis.categories = []
            this.top_keywords_gmv_chart_options.series = [
              {
                name: 'GMV',
                data: [],
                color: '#30b556',
              },
            ]

            for (const keyword of top_campaign_ids) {
              const keyword_found = this.search_campaign_result.keywords.find(i => i.keyword === keyword)
              this.top_keywords_gmv_chart_options.xAxis.categories.push(keyword_found.keyword)
              this.top_keywords_gmv_chart_options.series[0].data.push(keyword_found.metrics.gmv)
            }

            this.top_keywords_gmv_chart_options = this.clone(this.top_keywords_gmv_chart_options)
          }

          if (
            this.search_campaign_result.best_roas_for_same_period_keywords &&
            this.search_campaign_result.best_roas_for_same_period_keywords.length
          ) {
            const top_campaign_ids = this.search_campaign_result.best_roas_for_same_period_keywords.slice(0,
              this.select_top)
            this.top_keywords_roas_for_same_period_chart_options.xAxis.categories = []
            this.top_keywords_roas_for_same_period_chart_options.series = [
              {
                name: 'ROAS',
                data: [],
                color: '#30b556',
              },
              {
                name: 'ROAS cùng kỳ',
                data: [],
                color: 'purple',
              },
            ]

            for (const keyword of top_campaign_ids) {
              const keyword_found = this.search_campaign_result.keywords.find(i => i.keyword === keyword)
              this.top_keywords_roas_for_same_period_chart_options.xAxis.categories.push(keyword_found.keyword)
              this.top_keywords_roas_for_same_period_chart_options.series[0].data.push(
                +keyword_found.metrics.roas.toFixed(2),
              )
              this.top_keywords_roas_for_same_period_chart_options.series[1].data.push(
                +keyword_found.metrics.period_roas.toFixed(2),
              )
            }

            this.top_keywords_roas_for_same_period_chart_options = this.clone(
              this.top_keywords_roas_for_same_period_chart_options,
            )
          }

          if (
            this.search_campaign_result.best_gmv_for_same_period_keywords &&
            this.search_campaign_result.best_gmv_for_same_period_keywords.length
          ) {
            const top_campaign_ids = this.search_campaign_result.best_gmv_for_same_period_keywords.slice(0,
              this.select_top)
            this.top_keywords_gmv_for_same_period_chart_options.xAxis.categories = []
            this.top_keywords_gmv_for_same_period_chart_options.series = [
              {
                name: 'GMV',
                data: [],
                color: '#30b556',
              },
              {
                name: 'GMV cùng kỳ',
                data: [],
                color: 'purple',
              },
            ]

            for (const keyword of top_campaign_ids) {
              const keyword_found = this.search_campaign_result.keywords.find(i => i.keyword === keyword)
              this.top_keywords_gmv_for_same_period_chart_options.xAxis.categories.push(keyword_found.keyword)
              this.top_keywords_gmv_for_same_period_chart_options.series[0].data.push(keyword_found.metrics.gmv)
              this.top_keywords_gmv_for_same_period_chart_options.series[1].data.push(
                keyword_found.metrics.period_gmv)
            }

            this.top_keywords_gmv_for_same_period_chart_options = this.clone(
              this.top_keywords_gmv_for_same_period_chart_options,
            )
          }

          await this.m__get_added_keywords_from_atosa_agent()
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.get_data = false
      }
    },

    async m__get_added_keywords_from_atosa_agent() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/get_added_keywords', {
        shop_id: this.shop._id,
        campaign_id: this.selected_campaign_id,
      }, this.cf())
      this.added_keywords_from_atosa_agent = response.body.data || []
      this.added_keywords_from_atosa_agent_set = new Set(this.added_keywords_from_atosa_agent)
    },

    m__reload_data() {
      if (this.tab === '1') this.m__get_data_by_shop()
      if (this.tab === '2') this.m__get_data_by_campaign()
    },

    m__go_to_campaign(e, campaign_id) {
      if (e) e.preventDefault()

      this.selected_campaign_id = campaign_id
      this.tab = '2'
      this.m__get_data_by_campaign()
    },

    m__analyze_keyword_metrics_html(keywords) {
      const metrics_map = [
        {
          key: "impression",
          label: "Lượt xem"
        },
        {
          key: "click",
          label: "Lượt click"
        },
        {
          key: "ctr",
          label: "Tỷ lệ click"
        },
        {
          key: "cpc",
          label: "CPC"
        },
        {
          key: "cost",
          label: "Chi phí"
        },
        {
          key: "cr",
          label: "Tỷ lệ chuyển đổi"
        },
        {
          key: "gmv",
          label: "Doanh thu"
        },
        {
          key: "roas",
          label: "ROAS"
        }
      ];

      const escape_html = (str) =>
        str.replace(/</g, "&lt;").replace(/>/g, "&gt;");

      function round(value) {
        return Math.round(value * 100) / 100;
      }

      let html = `<div class="space-y-6 leading-relaxed">`;

      metrics_map.forEach(({
                             key,
                             label
                           }, index) => {
        const increased = [];
        const decreased = [];
        const increased_percents = [];
        const decreased_percents = [];
        const gmv_higher = [];
        const gmv_lower = [];
        const roas_higher = [];
        const roas_lower = [];

        for (const item of keywords) {
          const kw = item.keyword;
          const cur = item.metrics[key] || 0;
          const prev = item.metrics[`period_${key}`] || 0;
          const gmv = item.metrics.gmv || 0;
          const prev_gmv = item.metrics.period_gmv || 0;
          const roas = item.metrics.roas || 0;
          const prev_roas = item.metrics.period_roas || 0;

          if (cur > prev) {
            increased.push(kw);
            increased_percents.push(prev !== 0 ? ((cur - prev) / prev) * 100 : 100);
            if (gmv > prev_gmv) gmv_higher.push(kw);
            if (roas > prev_roas) roas_higher.push(kw);
          } else if (cur < prev) {
            decreased.push(kw);
            decreased_percents.push(prev !== 0 ? ((prev - cur) / prev) * 100 : 0);
            if (gmv < prev_gmv) gmv_lower.push(kw);
            if (roas < prev_roas) roas_lower.push(kw);
          }
        }

        const avg_increase = increased_percents.length
          ? round(increased_percents.reduce((a, b) => a + b, 0) / increased_percents.length)
          : 0;
        const avg_decrease = decreased_percents.length
          ? round(decreased_percents.reduce((a, b) => a + b, 0) / decreased_percents.length)
          : 0;

        const show_gmv = key !== "gmv";
        const show_roas = key !== "roas";

        const format_line = (title, arr) => {
          const count = arr.length;
          if (count === 0) return `<li><strong>${title}:</strong> 0 từ khóa</li>`;
          return `<li><strong>${title}:</strong> ${count} từ khóa <br> (${escape_html(arr.join(", "))})</li>`;
        };

        const toggle_id = `toggle-${key}-${index}`;

        html += `
    <div class="border border-gray-200 rounded-lg p-6 bg-white shadow-sm">
      <p class="text-sm font-bold text-blue-700 mb-5 !text-[13px]">${index + 1}. ${label}</p>
      <ul class="list-disc pl-5 space-y-2 mb-[5px]">
        ${format_line("Tăng", increased)}
        ${format_line("Giảm", decreased)}
        <li><strong>% trung bình tăng:</strong> +${avg_increase}%</li>
        <li><strong>% trung bình giảm:</strong> -${avg_decrease}%</li>
      </ul>
      <button onclick="document.getElementById('${toggle_id}').classList.toggle('hidden')"
        class="text-blue-600 hover:underline text-[13px] font-semibold">Xem thêm</button>
      <ul id="${toggle_id}" class="hidden mt-2 list-disc pl-5 space-y-2">
        ${show_gmv ? format_line("Số từ khóa tăng có GMV Cao hơn cùng kỳ", gmv_higher) : ""}
        ${show_roas ? format_line("Số từ khóa tăng có ROAS Cao hơn cùng kỳ", roas_higher) : ""}
        ${show_gmv ? format_line("Số từ khóa giảm có GMV Thấp hơn cùng kỳ", gmv_lower) : ""}
        ${show_roas ? format_line("Số từ khóa giảm có ROAS Thấp hơn cùng kỳ", roas_lower) : ""}
      </ul>
    </div>`;
      });

      html += `</div>`;
      return html;
    }
  },
}
</script>

<style lang="scss">
ul.list-disc {
  li {
    font-size: 13px !important;

    strong {
      font-size: 13px !important;
    }
  }
}

.hide-closeable {
  .el-range__close-icon {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/log/auto_by_ai_performance.vue